import React from 'react'
import { cn } from '@/lib/utils'

interface TurnTimerProps {
    progress: number // 0 to 100
    isLowTime: boolean
    isMyTurn: boolean
}

export function TurnTimer({ progress, isLowTime, isMyTurn }: TurnTimerProps) {
    return (
        <div className="w-full h-1 relative overflow-hidden group">
            {/* Background Track */}
            <div className="absolute inset-0 bg-neutral-900/40" />

            {/* 
        The Spectral Progress Bar 
        We use a layered approach for the color:
        1. Base color (smooth transition)
        2. Glow layer (smooth transition)
        3. Gradient flow (animated)
      */}
            <div
                className={cn(
                    "absolute inset-y-0 right-0 transition-all duration-1000 ease-linear rounded-l-sm",
                    !isMyTurn && "opacity-20 grayscale"
                )}
                style={{
                    width: `${progress}%`,
                }}
            >
                {/* Color Base Layer - Handles the smooth color transition */}
                <div
                    className={cn(
                        "absolute inset-0 transition-colors duration-1000 ease-linear",
                        isLowTime ? "bg-fuchsia-600" : "bg-cyan-500"
                    )}
                />

                {/* Shimmer / Flow Layer - Always active to feel magical */}
                <div
                    className="absolute inset-0 animate-mana-flow opacity-60 bg-gradient-to-r from-white/0 via-white/40 to-white/0"
                />

                {/* Glow Shadow - Matches the current color phase */}
                <div
                    className={cn(
                        "absolute inset-0 transition-all duration-1000 ease-linear blur-[2px]",
                        isLowTime
                            ? "shadow-[0_0_15px_rgba(217,70,239,0.8)]"
                            : "shadow-[0_0_15px_rgba(6,182,212,0.6)]"
                    )}
                />
            </div>
        </div>
    )
}
